import React, { useState } from 'react'
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
const DateTimePicker = ({ label, setDate, intialStartdate, initialEnddate,isEducationList }) => {
    const [startDate, setStartDate] = useState(intialStartdate);
    const [endDate, setEndDate] = useState(initialEnddate !== "Present" ? initialEnddate : new Date())
    const [checked, setChecked] = React.useState(initialEnddate !== "Present" ? false : true);


    //     const [startDate, setStartDate] = useState(startdate || new Date());
    //     const [endDate, setEndDate] = useState(enddate!=="Present" ? endDate :new Date());
    //     const [checked, setChecked] = React.useState(enddate!=="Present" ? false : true);


    const handleDate = (date, isStartDate) => {
        const month = String(date?.getMonth() + 1).padStart(2, '0');
        const year = date?.getFullYear();
        let formattedDate = `${month}/${year}`;
        formattedDate = formattedDate !== 'NaN/undefined' ? formattedDate : '';
        if (isStartDate) {
            setDate(formattedDate, 'startDate')
            setStartDate(date);
        } else {
            setDate(formattedDate, 'endDate')
            setEndDate(date)
        }


    }

    const handleCheckbox = (e) => {
        setChecked(e.target.checked)
        if (e.target.checked) {
            setDate('Present', 'endDate')
        } else {
            handleDate(new Date(), false)
        }


    }
    return (
        <div className='my-1'>
            <div className='flex items-center justify-between'>
                <label className="block text-sm font-medium text-gray-700">{label}</label>
                <div className='flex mr-2 items-center'><div className='text-gray-700 font-medium hidden md:block md:text-xs m-1'>Currently {isEducationList ? 'study' :'work'} here</div> <div className='hidden md:block'><input value="test" type="checkbox" checked={checked} onChange={handleCheckbox} /> </div> </div>

            </div>
            <div className='flex md:gap-4 gap-2 mt-1'>
                <div className='w-[50%]'>
                    <DatePicker weekAriaLabelPrefix='' className='w-full py-2 px-2 md:px-4 md:py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 text-xs md:text-base' selected={startDate} dateFormat="MM/yyyy" showMonthYearPicker onChange={(date) => handleDate(date, true)} />
                </div>
                <div className='w-[50%]'>
                    {checked ? <div className='text-xs md:text-base w-full px-2 md:px-4 py-2 bg-white border border-gray-300 rounded-lg shadow-sm'>Present</div> : <DatePicker className='w-full py-2 px-2 md:px-4 md:py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 text-xs md:text-base' selected={endDate} dateFormat="MM/yyyy" showMonthYearPicker onChange={(date) => handleDate(date, false)} />}
                </div>
            </div>

            <div className='flex mr-2 items-center'>
                <div className='text-gray-700 font-medium md:hidden text-xs mx-1 mt-1'>Currently {isEducationList ? 'study' :'work'} here</div>
                <input value="test" type="checkbox" className='md:hidden w-3 h-3 mt-1' checked={checked} onChange={handleCheckbox} />
            </div>


        </div>

    )
}

export default DateTimePicker